export const Href = "#javascript";

// Layout
export const DefaultDashboard = "Default dashboard";
export const Dashboard = "Dashboard";
export const Default = "Default";
export const Notification = "Notification";
export const CheckAll = "Check All";
export const Back = "Back";
export const Bookmark = "Bookmark";
export const AddNewBookmark = "Add New Bookmark";
export const Messages = "Messages";
export const Cart = "Cart";
export const Checkout = "Check out";
export const Pinned = "Pinned";
export const SearchCrocs = "Search Employee...";
export const English = "English";
export const Deutsch = "Deutsch";
export const Español = "Español";
export const Français = "Français";
export const Português = "Português";
export const 简体中文 = "简体中文";
export const LightLayout = "Light layout";
export const DarkLayout = "Dark Layout";

// Dashboard
export const Weekly = "Weekly";
export const Monthly = "Monthly";
export const Yearly = "Yearly";

// Ui-Kits
export const StylerBorders = "Styler Borders";
export const CustomBorderRadiusClass = "Custom border-radius class";
export const BorderColor = "Border Color";
export const BorderWidth = "Border Width";
export const BackgroundColors = "Background Colors";
export const TextColors = "Text Colors";
export const AdditiveBorder = "Additive border";
export const SubtractiveBorder = "Subtractive border";
export const AdditiveRadiusHeading = "Additive radius";
export const DarkBackground = "Dark background";
export const LightBackground = "Light background";
export const BordersAndDisplays = "Borders and displays";
export const ExtendedBackgroundColor = "Extended Background Color";
export const GridOptions = "Grid options";
export const GridBehavior = "Grid behavior";
export const HorizontalAllTimes = "Horizontal at all times";
export const CollapsedBreakpoints =
  "Collapsed to start, horizontal above breakpoints";
export const MaxContainerWidth = "Max container width";
export const ClassPrefix = "Class prefix";
export const GridForColumn = "Grid For Column";
export const VerticalAlignment = "Vertical Alignment";
export const Class = " Class";
export const ValueOfClass = "Value of the class";
export const VerticalAlignmentClass = ".align-items-*";
export const VerticalAlignmentValueClass =
  " start / center / end / baseline / stretch";
export const HorizontalAlignment = "Horizontal Alignment";
export const HorizontalAlignmentValueClass =
  "start / center / end / around / between";
export const HorizontalAlignmentClass = ".justify-content-*";
export const Nesting = "Nesting";
export const Order = "Order";
export const OrderClass = ".order-*";
export const OrderValueClass = " first / 2 / 3 / 4 / 5 / last";
export const Offset = "Offset";
export const OffsetClass = ".offset-*";
export const OffsetValueClass = " 1 / 2 / ... / 11 / 12";
export const TotalSell = "Total Sells";
export const OrdersValue = "Orders Value";
export const DailyOrders = "Daily Orders";
export const DailyRevenue = "Daily Revenue";
export const SalesOverviews = "Sales Overview";
export const FontSizes = "Font Sizes";
export const RecentCustomer = "Recent Customers";
export const RevenueByCategorys = "Revenue By Category";
export const UserContinent = "User by Continent";
export const AllOverContriesSales = "All Over Contries's Sale";
export const Color = "Color";
export const ImagesSizes = "Images Sizes";
export const FontStyle = "Font-Style";
export const SpecialDiscount = "Special Discount";
export const Days = "Days";
export const Hours = "Hours";
export const Margin = "Margin";
export const Min = "Min";
export const Sec = "Sec";
export const Topsellermonth = "Top seller of the month";
export const RecentOrder = "Recent Orders";
export const DealDayFrom = "Deal of the Day From ";
export const SelectSize = "Select size";

// Ui-kits
export const Headings = "Headings";
export const Typography = "Typography";
export const Code = "Code";
export const FontSize = "Font Size";
export const Heading = "Heading";
export const ColoredHeadings = "Colored Headings";
export const FontWeight = "Font Weight";
export const FontWeightTitle = "You can set bolder font weight Heading";
export const ListingTypography = "Listing Typography";
export const UnOrderList = "Unorder List";
export const OrderLists = "Order Lists";
export const DescriptionLists = "Description Lists";
export const DisplayHeadings = "Display Headings";
export const InlineTextElements = "Inline Text Elements";
export const TextColor = "Text Color";
export const Blockquote = "Block quotes";
export const Sizes = "Sizes";
export const StatusIndicator = "Status Indicator";
export const Shapes = "Shapes";
export const Ratio = "Ratio";
export const Grouping = "Grouping";
export const TagAndPills = "Tag & Pills";
export const BadgesContextualVariations = "Badges Contextual Variations";
export const PillsContextualVariations = "Pills Contextual Variations";
export const NumberOfBadge = "Number of Badge ";
export const NumberOfPillsTags = "Number of Pills Tags";
export const BadgeTagsWithIcons = "Badge Tags With Icons";
export const RoundedPillsWithIcons = "Rounded Pills With Icons";
export const BadgeHeadingsExample = "Badge Headings Example";
export const BadgesAsPartButtons = "Badges As Part Buttons";

//Ui Kits- Progress
export const Progress = "Progress";
export const BasicProgressBars = "Basic Progress Bars";
export const ProgressBarsStriped = "Progress Bars Striped";
export const ProgressBarsAnimated = "Progress Bars animated";
export const MultipleBars = "Multiple bars";
export const ProgressWithNumberSteps = "Progress With Number Steps";
export const CustomProgressBars = "Custom Progress Bars";
export const SmallProgressBars = "Small Progress Bars";
export const LargeProgressBars = "Large Progress Bars";
export const GettingStarted = "0% Getting Started ";
export const CustomHeightProgressBars = "Custom Height Progress Bars";
export const OnlyOneSideMargin = "Only one side margin";
export const OnlyOneSidePadding = "Only one side padding";

//Ui Kits- Modal
export const Modal = "Modal";
export const BasicModal = "Basic Modal";
export const Simple = "Simple";
export const ScrollingContent = "Scrolling content";
export const UXDesigners = "UX Designer ";
export const OpenModalForCrocs = "Open modal for Crocs";
export const WebDesigns = "Web Design ";
export const CrocsSignUp = "Crocs SIGN-UP";
export const CrocsEmail = "Crocstheme@gmail.com";
export const CrocsLogin = "Crocs Login";
export const ScrollingModalHeading = "Scrolling Modal";
export const TooltipsAndPopovers = "Tooltips and popovers";
export const PopoverModal = "Popover in a modal";
export const TooltipsModal = "Tooltips in a modal";
export const CrocsCustomModal = "Crocs Custom Modals ";
export const OpenModalForMofi = "Open modal for Crocs";
export const SizesModal = "Sizes Modal";
export const FullScreenModals = "Full Screen Modal";
export const ExtraLargeModals = "Extra large Modal";
export const LargeModals = "Large Modal";
export const SmallModals = "Small Modal";
export const FullScreenModal = "Fullscreen Modal";
export const TooltipPopoverModal = "Tooltip and Popover Modal";
export const FullScreenBelowSM = "Full Screen Below sm";
export const FullScreenBelowMD = "Full Screen Below md";
export const FullScreenBelowLG = "Full Screen Below lg";
export const FullScreenBelowXL = "Full Screen Below xl";
export const FullScreenBelowXXL = "Full Screen Below xxl";
export const CenteredModals = "Centered Modal ";
export const VerticallyCentered = "Vertically centered";
export const ToggleBetweenModal = "Toggle Between Modals ";
export const OpenFirstModal = "Open first Modal ";
export const StaticBackdropModals = "Static Backdrop Modal";
export const BalanceAmount = "$768,987.90";
export const Cancel = "Cancel";
export const Save = "Save";
export const Close = "Close";
export const SaveChanges = "Save changes";
export const ClickOut = "Click Out";
export const StaticBackdropModalBtn = "Static backdrop modal";
export const SomethingWentWrong = "Ohh! Something went wrong!";
export const AlreadyLeaving = "Already leaving??";
export const YesLogOut = "Yes, Log out";
export const ParentToggleTitle =
  "Remove your complete account from your phone or tablet to sign out of the Gmail app.";
export const ConnectNewAccount = "Connect new account";
export const ConnectNewRegisterAccount = "Register";
export const SignUp = "Sign Up";
export const FirstName = "First name";
export const LastName = "Last name";
export const EnterYourFirstName = "Enter your first-name";
export const EnterYourLastName = "Enter your last-name";
export const TermsAndCondition =
  "You accept our Terms and Privacy Policy by clicking Submit below.";
export const ExtraLargeModal = "Extra large modal";
export const WebDesign = "Web Design";
export const StartWithYourGoals = "Start with your goals";
export const FullscreenModal = "Fullscreen modal";
export const Email = "Email";
export const CheckMeOut = "Check me out";

//Ui Kits- Popover
export const Popover = "Popover";
export const HurryUps = "Hurry Up!";
export const BasicPopovers = "Basic Popover";
export const PopoverOnTop = " Popover on top";
export const PopoverOffsets = "Popover Offset ";
export const PopoverDirections = "Popover Direction";
export const PopoverOffset50 = "Popover offset 50";
export const PopoverTitle = "Popover Title";

//Ui Kits- Alert
export const LinkColorDarkTheme = "Link Color In Dark Theme";
export const LinkColorLightTheme = "Link Color In Light Theme";
export const OutlineDarkLightAlerts = "Outline Dark And Light Alerts";
export const AlertsWithIconsTextActions = "Alerts With Icons and Text Actions";
export const DismissingDarkAlert = "Dismissing Dark Alerts";
export const DismissingLightAlert = "Dismissing Light Alerts";
export const LiveAlerts = "Live Alert";
export const ShowLiveAlert = "Show live alert";
export const LeftBorderAlerts = "Left Border Alert";
export const AdditionalContents = "Additional content";
export const PleaseCheckYourNotifications = "Please! Check your notifications";
export const Check = "Check";

//Ui Kits- Tooltip
export const Tooltip = "Tooltip";
export const TooltipSmall = "tooltip";
export const BasicTooltip = "Basic Tooltip";
export const DirectionsTooltip = "Tooltip  directions";
export const MagicPleaseHoverMe = "It's magic please hover me...";
export const InlineTooltipContent = "Inline Tooltip Content";
export const ColoredTooltips = "Colored Tooltip ";
export const DirectionsdTooltip = "Tooltip  Directions";
export const TooltipOnTop = "Tooltip on tops";
export const HTMLElementsWithHoverEffect = "HTML Elements With Hover Effect";
export const NotificationsReceived = "Notifications Received";
export const FilledTooltips = "Filled Tooltip";
export const TooltipPrimary = "Tooltip Primary";
export const ThankYouBold = "<b>Thank</b> <em>you</em>";
export const ThankYouItalic = "<i>Thank </i> <u>you</u>";
export const ButtonSmall = "Button";

//Ui Kits - Dropdown
export const DropdownTitle = "Dropdown";
export const Dropdown = "Dropdown";
export const BasicDropdowns = "Basic Dropdown";
export const RoundedDropdowns = "Rounded Dropdown";
export const SplitDropdowns = "Split Dropdown";
export const Widgets = "Widgets";
export const Party = "Party";
export const Primary = "Primary";
export const Inputs = "Inputs";
export const SignIn = "Sign in";
export const HeadingDropdowns = "Heading Dropdown";
export const WithInputTypes = "With Input Type";
export const DarkDropdowns = "Dark Dropdown";
export const DarkNight = "Dark Night";
export const UniqueDropdownHeading = "Unique Dropdown";
export const DropdownForms = "Dropdown form";
export const Text = "Text";
export const JustifyContent = "Justify Contents";
export const TextLeft = "Text-left";
export const Alignment = "Alignments";
export const WarningTop = "Warning top";
export const HelperCards = "Helper Card";
export const LearnMore = "Learn More!";
export const WarningCards = "Warning Card";
export const Warning = "Warning!";
export const AlertCards = "Alert Card";
export const Danger = "Danger";
export const DividerDropdowns = "Divider Dropdown";
export const Wishlist = "Wishlist";
export const DropdownSizings = "Dropdown Sizing";
export const LargeButton = "Large button";
export const Emailaddress = "Email address";
export const Password = "Password";
export const RememberMe = "Remember me";

//Ui Kits - Accordion
export const Accordion = "Accordion";
export const Accordions = "Accordion";
export const SimpleAccordions = "Simple Accordion";
export const FlushAccordions = "Flush Accordion";
export const WhatDoWebDesignersDo = "What do web designers do ?";
export const MultipleCollapseAccordions = "Multiple Collapse Accordion";
export const ToggleFirstElement = "Toggle first element";
export const ToggleSecondElement = "Toggle second element";
export const ToggleBothElement = "Toggle both element";
export const WithIconsAccordions = "With Icons Accordion";
export const OutlineAccordions = "Outline Accordion ";
export const HorizontalAccordions = "Horizontal Accordion";
export const ToggleWidthCollapse = "Toggle width collapse";
export const CollapseAccordions = "Collapse Accordion";
export const LinkWithHref = "Link with href";
export const ButtonWithDataBsTarget = "Button with data-bs-target";

//Ui Kits- Tabs
export const ReactstrapTabs = "Reactstrap Tabs";
export const EmailAddress = "Email Address";
export const Tabs = "Tabs";
export const SimpleTab = "Simple tabs";
export const IconsWithTab = "Icons With Tabs";
export const VerticalTab = "Vertical Tabs";
export const PillsTab = "Pills tabs";
export const JustifyTab = "Justify Tabs";
export const MaterialStyleLeftTab = "Material Style Left Tabs";
export const DalbultCaslin = "Dalbult Caslin ";
export const MaterialStyleTab = "Material Style Tabs";
export const BorderTab = "Border Tabs ";
export const Contact = "Contact";
export const Components = "Components";
export const PageTab = "Page";
export const AboutUs = "About us";
export const Blog = "Blog";
export const Inbox = "Inbox";
export const UxDesigner = "UX designer";
export const IOTDeveloper = "IOT developer";
export const WebDesigner = "Web Designer";
export const User = "User";
export const Description = "Description";
export const Review = "Review";
export const ExampleTextarea = "Example textarea";

//Ui Kits - Lists
export const Lists = "Lists";
export const DefaultList = "Default Lists ";
export const ActiveList = "Active Lists ";
export const FlushList = "Flush Lists";
export const ContextualClassesHeading = "Contextual classes";
export const HorizontalList = "Horizontal Lists";
export const CustomContentList = "Custom Content Lists";
export const MollyBoake = "Molly Boake";
export const ListsWithCheckboxs = "Lists With Checkbox";
export const ListsWithRadio = "Lists With Radios";
export const ListsWithNumber = "Lists With Numbers";
export const JavaScriptBehaviors = "JavaScript Behavior";
export const NumberedBadgeList = "Numbered & Badge Lists";
export const DisabledList = "Disabled Lists ";
export const ScrollableList = "Scrollable Lists ";
export const Home = "Home";
export const Profile = "Profile";
export const ContactUs = "Contact us";
export const Settings = "Settings";

// Page Layout
export const SampleCards = "Sample Card";

// Widgets
export const WebsiteDesigns = "Website Design";
export const SquareDashboard = "Square Dashboard";
export const Design3D = "3D Design";
export const Visitor = "Visitors";
export const UpcomingAppointments = "Upcoming Appointment";
export const MonthlyHistorys = "Monthly History";
export const SkillStatusHeading = "Skill Status";
export const OrdersStatusHeading = "Order Status";
export const LiveProduct = "Live Products";
export const TurnOver = "Turn over";
export const CryptocurrencyPrice = "Cryptocurrency Prices";
export const StockMarkets = "Stock Market";
export const Finances = "Finance";
export const MonthlySale = "Monthly Sales";
export const CryptoAnnotation = "Crypto Annotations";
export const OrdersStatus = "Order Status";
export const Uses = "Uses";
export const StudyStatistic = "Study Statistics";
export const UXDesign = "UX Design";
export const Illustrations = "Illustrations";
export const Assignments = "Assignments";
export const LiveMeetings = "Live Meeting";
export const ActivelyHour = "Actively Hours";
export const EnrolledClass = "Enrolled Classes";
export const MonthlyAttendances = "Monthly Attendance Report (Feb)";
export const Schedules = "Schedule";
export const TransactionHistoryHeading = "Transaction History";
export const TopSellingProductHeading = "Top Selling Product";
export const FeaturedCourse = "Featured Courses";
export const Keyboard = "Keyboard";
export const Laptops = "Laptops";
export const Desktop = "Desktop";
export const Mouse = "Mouse";

//Icon
export const Icons = "Icons";
export const FlagIcon = "Flag Icons";
export const FontAwesomeIcons = "Font Awesome Icon";
export const Currency = "Currency";
export const WebApp = "Web App";
export const Spinner = "Spinner";
export const FormControl = "Form Control";
export const TextEditor = "Text Editor";
export const Directional = "Directional";
export const VideoPlayer = "Video Player";
export const BrandPlayer = "Brand Player";
export const Medical = "Medical";
export const IcoIcon = "ICO Icon";
export const Abstract = "Abstract";
export const Sport = "Sport";
export const Social = "Social";
export const Weather = "Weather";
export const WhetherIconsWithAnimations = "Whether Icons With Animations";
export const WebApplication = "Web Application";
export const Travel = "Travel";
export const Transport = "Transport";
export const Multimedia = "Multi media";
export const MobileUI = "Mobile UI";
export const Mathematical = "Mathematical";
export const Animal = "Animal";
export const Brand = "Brand";
export const Construction = "Construction";
export const Device = "Device";
export const Education = "Education";
export const FileType = "File Type";
export const Food = "Food";
export const Law = "Law";
export const Business = "Business";
export const Emoticon = "Emoticon";
export const KidsToys = "Kids & Toys";
export const Payment = "Payment";
export const Person = "Person";
export const ThemifyIcon = "Themify Icon";
export const ArrowsDirection = "Arrows & Direction ";
export const Control = "Control";
export const FeatherIcons = "Feather Icons";
export const WhetherIcon = "Whether Icon";
export const whetherIconsWithAnimations = "Whether Icons With Animations";
export const CopyText = "Copy text";
export const Markup = "Markup";

//Bonus Ui - Timeline
export const BonusUi = "Bonus Ui";
export const Location = "Location";

//Bonus Ui - Basic Card
export const BasicCardHeading = "Basic Card";
export const FlatCards = "Flat Card";
export const WithoutShadowCards = "Without shadow Card";
export const CrocsTheme = "Crocs Theme";
export const IconInHeadings = "Icon In Heading";
export const DarkColorCards = "Dark Color Card";
export const FooterCard = "Card Footer";
export const SmartHeadphones = "Smart headphones";

//Bonus Ui - Creative Card
export const CreativeCard = "Creative Card";
export const BorderLefts = "Border Left";
export const BorderRights = "Border Right";
export const TopBorder = "Border Top";
export const BottomBorder = "Border Bottom";
export const TeresaMosteller = "Teresa J. Mosteller";
export const GloriaAcheson = "Gloria D. Acheson";
export const BryanOwens = "Bryan A. Owens";
export const PrimaryBorderState = "Border Primary State";
export const WarningBorderState = "Border Warning State";
export const SecondaryBorderState = "Border Secondary State";
export const EmailAddressPlaceHolders = "youremail@gmail.com";
export const Timeline = "Timeline";
export const ConferenceWithClient = "CONFERENCE WITH CLIENT";
export const AbsoluteCards = "Absolute Card";

//Bonus Ui - Range Slider
export const RangeSlider = "Range Slider";
export const DefaultRangeSliders = "Default Range Slider";
export const MinMaxValues = "Min Max Value";
export const NegativeValues = "Negative Value";
export const Disable = "Disabled";
export const Prefixs = "Prefix";
export const FormatedLabels = "Formated Label";

//Bonus Ui - Image-Cropper
export const ImageCropper = "Image Cropper";
export const HiddenDownload = "Hidden download";
export const DownloadCrop = "Download Crop";

//Bonus Ui - OwlCarousel
export const OwlCarousel = "Owl Carousel";
export const SlideOnly = "Slides Only";
export const WithControl = "With Controls";
export const AutoPlayVariants = "Auto Play Variant";
export const ExploreMore = "Explore More";
export const MouseWheelVariants = "Mouse Wheel Variant";
export const WithIndicator = "With Indicators";
export const WithCaption = "With Captions";
export const CrossFades = "Cross-Fade";
export const IndividualCarouselItemIntervals =
  "Individual Carousel-Item Interval";
export const DisableTouchSwipings = "Disable Touch Swiping";
export const DarkVariants = "Dark Variant";

//Bonus Ui - Tour
export const Tour = "Tour";
export const WilliamJennings = "William C. Jennings";
export const WebDesignerTour = " Web Designer";
export const FollowerTour = "Follower";
export const FollowingTour = "Following";
export const WonderFullTour =
  "Wonderful piece that successfully conveys the magnificence of the mountains and the natural world.";
export const ReadMoreTour = "ReadMore";
export const PainterTourTitle =
  "English Romantic painter, printer, and watercolourist ";

//Bonus Ui - Ribbons
export const Ribbons = "Ribbons";
export const VariationsOfLeftRibbons = "Variations Of Left Ribbons";
export const VariationsOfRightRibbons = "Variations Of Right Ribbons";
export const CssRibbons = "CSS ribbons ";
export const RibbonLeftText2 = "to identify your items.";

//Bonus Ui - Dropzone
export const Dropzone = "Dropzone";
export const DefaultFileUploads = "Default File Upload";
export const PreviewImage = "Image Preview ";
export const SingleFileUploads = "Single File Upload";
export const MultiFileUploads = "Multi File Upload";
export const DropFilesHereOrClickToUpload =
  "Drop files here or click to upload.";

//Bonus Ui - Sweet Alerts
export const SweetAlert = "Sweet Alert";
export const Alert = "Alert";
export const BasicExamples = "Basic Example";
export const ClickIt = "Click it!";
export const Surprise = "Surprise!";
export const TitleWithATextUnder = "Title With A Text Under";
export const InfoAlerts = "Info Alert";
export const Informational = "Informational";
export const WarningAlerts = "Warning Alert ";
export const SweetWarningButton = "Warning";
export const PikachuAlerts = "Pikachu Alert";
export const Pikachu = "Pikachu";
export const QuestionsAlerts = "Questions Alert ";
export const QuestionsState = "Questions state";
export const UsernameAlerts = "Username Alert";
export const SuccessMessages = "Success Message";
export const LoginSuccessfully = "Login successfully";
export const DangerAlerts = "Danger Alert ";
export const DangerMode = "Danger mode";
export const WarningModes = "Warning Mode";
export const AlertMode = "Alert mode";
export const Timer = "Timer";
export const AjaxRequestMovies = "AJAX Request Movie";
export const MovieMode = "Movie mode";
export const Username = "Username";

//Pagination
export const Pagination = "Pagination";
export const DefaultPaginations = "Default Pagination";
export const PaginationWithActiveAndDisabled =
  "Pagination With Active And Disabled";
export const PaginationWithIcon = "Pagination With Icons";
export const RoundedPaginations = "Rounded Pagination";
export const PaginationAlignments = "Pagination Alignment";
export const PaginationSizings = "Pagination Sizing";
export const NextData = ["1", "2", "3", "...", "20"];

//Bonus Ui - Toasts
export const Toasts = "Toasts";
export const LiveToasts = "Live Toast";
export const TopRightToasts = "Top-right toast";
export const BottomRightToasts = "Bottom-right toast";
export const TopLeftToasts = "Top-left toast";
export const BottomLeftToasts = "Bottom-left toast";
export const YourAccountWillBePermanentlyDeleted =
  "Your account will be permanently deleted?";
export const ImNotSure = "I'm not sure";
export const RemoveMyAccount = "Remove My Account";
export const ColorsScheme = "Colors Schemes";
export const StackingToast = "Stacking Toasts";
export const TranslucentToast = "Translucent Toasts";
export const DefaultToasts = "Default Toast";
export const UniqueToasts = "Unique Toast";
export const ToastPlacements = "Toast Placement";

//Bonus Ui - Rating
export const RatingBars = "1 to 10 Rating Bar";
export const MovieRatingBar = "Movie Rating Bar";
export const SquareRatingBar = "Square Rating Bar";
export const PillRatingBar = "Pill Rating Bar";
export const ReversedRatingBar = "Reversed Rating Bar";
export const StarRatingBar = "Star Rating Bar";
export const HalfStarRatingBar = "Half Star Rating Bar";
export const ThumbUpDownRate = "Thumb Up/Down Rating Bar";
export const HeartRatingBar = "Heart Rating Bar";
export const Rating = "Rating";

//Bonus Ui - Scrollable
export const CustomScrollbars = "Custom Scrollbar";
export const SmallSizeScrollbars = "Small Size Scrollbar";
export const SolutionBusinessTransformation =
  "Solution for Business Transformation";
export const BadgesScrollbars = "Badges Scrollbar";
export const ProfileScrollables = "Profile Scrollable";
export const ScrollableContents = "Scrollable Content";
export const HorizontalScrollbars = "Horizontal Scrollbar ";
export const BothSideVisibleScrollbars = "Both Side Visible Scrollbar";

//Reactstrap Table - Table Components
export const TableComponent = "Table Component";
export const UIComponentsTitle = "UI Components";
export const DefaultButtonsTitle = "Default Buttons";
export const AlertTitle = "Alerts";
export const ProgressbarTitle = "Progressbar";
export const CheckboxTitle = "Checkbox";
export const RadioButtonsTitle = "Radio Buttons";
export const SelectTable = "Select";
export const InputsTable = "Input";
export const BadgesTable = "Badges";
export const TooltipTriggersTitle = "Tooltip Triggers";
export const SwitchTable = "Switch";
export const OutlineCustomButtonGroupHeading = "Outline Custom button group";
export const Select = "Select";

export const Resend = "Resend";

// //From Layout - wizard 1
export const ConfirmPassword = "Confirm Password";
export const Previous = "Previous";
export const Next = "Next";

//Switches
export const FormsWidgets = "Forms Widgets";
export const CustomSwitchHeading = "Custom switch";
export const IconsSwitchHeading = "Icons switch";
export const UncheckedSwitchHeading = "Unchecked switch";
export const BordersWithIcon = "Borders with icons";
export const DisabledOutlineSwitchHeading = "Disabled outline switch";
export const VariationOfSwitchHeading = "Variation of switches";
export const SwitchSizingHeading = "Switch sizing";
export const SwitchWithIcon = "Switch with Icons";

//Typeahead
export const Typeahead = "Typeahead";
export const BasicTypeaheadHeading = "Basic typeahead";
export const StatesOfUSA = "States of USA";
export const PreFetchHeading = "Prefetch";
export const BloodHoundHeading = "Bloodhound (Suggestion Engine)";
export const RemotelyAheadHeading = "Remote typeahead";
export const CustomTemplate = "Custom templates";
export const MultipleSectionWithHeader = "Multiple sections with headers";
export const ScrollableDropDownMenuHeading = "Scrollable Dropdown Menu";
export const RTLSupportHeading = "RTL Support";

//Datepicker
export const Datepicker = "Datepicker";
export const CalendarDefault = "Default calendar";
export const CalendarBootstrap = "Reactstrap calendar";
export const DatePickers = "Date picker";
export const CustomizingConjunction = "Customizing Conjunction";
export const DefaultDates = "Default Date";
export const DisabledDates = "Disabled Dates";
export const HumanFriendly = "Human Friendly";
export const MinMaxValue = "Min-Max Value";
export const MultiplesDates = "Multiples Dates";
export const Range = "Range";
export const TimePickerTitle = "Time picker";
export const TimePickers = "Time Picker";
export const DatePicker = "DatePicker";
export const MultiplesDatesHeading = "Multiples Dates";
export const RangeDatePicker = "Range";
export const PreloadingDates = "Preloading Dates";
export const TimPickers = "Time picker";
export const TimePickerHeading = "Time Picker";
export const HourPicker = "24-hour Time Picker";
export const TimePickerLimits = "Time Picker W/Limits";
export const PreloadingTime = "Preloading Time";
export const TimePickerRange = "TimePicker with Limited Time Range";
export const TimePickerMinMaxRange = "TimePicker with Min/Max Time Range";
export const DateWithTime = "Date With Time";
export const DateAndTimeHeading = "Date and time";
export const Month = "Month";
export const Week = "Week";
export const Time = "Time";
export const Date = "Date";
export const DateHeading = "Date Heading";

//Touchspin
export const Touchspin = "Touchspin";
export const DefaultTouchspins = "Default touchspin";
export const OutlinedTouchspins = "Outlined touchspin";
export const IconsWithPrefixAndPostfixs = "Icons with prefix and postfix";
export const ButtonsWithPrefixAndPostfixs = "Buttons with prefix and postfix";
export const PreText = "Pre";
export const PostText = "Post";
export const RoundedTouchspin = "Rounded touchspin";

//Input groups
export const InputGroup = "Input groups";
export const ButtonAddon = "Button addons";
export const SubmitButtonAddonPlaceHolder = "Recipient's username";
export const AddonPlaceHolder = "Recipient's username";
export const CustomForm = "Custom forms ";
export const OptionsFormGroup = "Options";
export const PixelstrapThemeTitle = "Select Your Favorite Pixelstrap theme";
export const FavoriteColorsTitle = "Select Your Favorite Colors";
export const FavoriteChocolatesTitle = "Select Your Favorite Chocolates";
export const FavoriteThemeTitle = "Select Your Favorite Theme";
export const CustomFileInputs = "Custom file input";
export const CustomFileInputsUpload = "Upload";
export const CustomFileInputsVerify = "Verify";
export const ButtonsWithDropdown = "Buttons with dropdowns";
export const ButtonsWithDropdownTitle = "Dropdown";
export const ToggleDropdown = "Toggle Dropdown";
export const SegmentedButton = "Segmented buttons";
export const SegmentedButtonInfo = "Info";
export const SegmentedButtonSecondary = "Secondary";
export const CheckboxesAndRadio = "Checkboxes and radios";
export const Sizings = "Sizing";
export const SmallInput = "Small";
export const DefaultInput = "Default";
export const LargeInput = "Large";
export const MultipleInput = "Multiple inputs";
export const FirstAndLastName = "First and last name";
export const BasicInputGroup = "Basic input groups";
export const BasicInputGroupBasic = "Basic";
export const YourVanityUrl = "Your vanity URL";
export const WithTextarea = "With textarea";
export const UsernamePlaceholder = "Username";
export const RecipientPlaceholder = "Recipient's username";
export const ServerPlaceholder = "Server";
export const Wrapping = "Wrapping";
export const ButtonBasicInputCancel = "Cancel";
export const VariationOfAddon = "Variation of addons";
export const LeftAddon = "Left Addon";
export const RightAddon = "Right Addon";
export const JointAddon = "Joint Addon";
export const LeftAddonPlaceholder = "Email";
export const RightAddonPlaceholder = "Recipient's username";
export const LeftAndRightAddon = "Left & Right Addon";
export const SolidStyle = "Solid style";
export const FlatStyle = "Flat style";
export const RaiseStyle = "Raise style";
export const LeftAndRight = "Left & Right Addon";
export const VariationOfAddonsCancel = "Cancel";

//Input Mask
export const InputMasks = `Input masks`;
export const DefaultInputMask = "Default Input Mask";
export const DateFormatHeading = "Date Format";
export const DateFormatType = "Date format type";
export const TimeFormatHeading = "Time Format";
export const TimeFormatType = "Time format type";
export const HourMonthType = "Hour/month type";
export const CurrencyPlaceholder = "hh:mm";
export const Prefix = "Prefix";
export const PrefixPlaceholder = "Prefix-xxxx-xxxx-xxxx";
export const Delimiter = "Delimiter";
export const DelimiterPlaceholder = "xxx·xxx·xxx";
export const PhoneNumber = "Phone Number";
export const PhoneNumberPlaceholder = "(xxx)xxx-xxxx";
export const CardNumber = "Card Number";
export const CardNumberPlaceholder = "xxxx xxxx xxxx xxxx";
export const Tailprefix = "Tail prefix";
export const TailprefixPlaceholder = "0000.00€";

//Checkbox & Radio
export const FormsControls = "Forms Controls";
export const CheckboxAndRadio = "Checkbox & Radio";
export const DefaultCheckboxHeading = "Default checkbox";
export const DefaultCheck = "Default Checks";
export const DefaultCheckBox = "Default checkbox";
export const CheckedCheckbox = "Checked checkbox";
export const DisabledChecks = "Disabled Checks";
export const IndeterminateHeading = "Indeterminate";
export const IndeterminateCheckbox = "Indeterminate checkbox";
export const CustomCheckboxHeading = "Custom checkbox";
export const BorderedCheckboxHeading = "Bordered Checkbox ";
export const PrimaryCheckboxPrimary = "Primary - checkbox-primary";
export const IconCheckboxHeading = "Icon Checkbox ";
export const FilledCheckboxHeading = "Filled Checkbox";
export const WarningCheckboxSolidWarning = "Warning - checkbox-solid-warning ";
export const DefaultRadios = "Default radio";
export const CustomRadio = "Custom Radios";
export const DefaultRadioLabel = "Default radio";
export const DefaultCheckedRadio = "Default checked radio";
export const ImagesWithCheckboxs = "Images with checkbox";
export const ImagesWitRadio = "Images with radio";
export const CustomRadios = "Custom radio";
export const BorderedRadios = "Bordered Radio";
export const KohoTheme = "Koho Theme";
export const IconsRadios = "Icons Radio";
export const FilledRadios = "Filled Radio";
export const ProductRadio = "Product";
export const DefaultSwitch = "Default switches";
export const CustomSwitches = "Custom Switches";
export const DefaultSwitchCheckboxInput = "Default switch checkbox input";
export const CheckedSwitchCheckboxInput = "Checked switch checkbox input";
export const InlineInputType = "Inline input-types";
export const InlineCheckboxHeading = "Inline Checkbox";
export const InlineRadio = "Inline Radios";
export const InlineSwitches = "Inline Switches";
export const AnimatedButton = "Animated buttons";
export const SelectYourPaymentMethods = "Select your payment method";
export const VisaAnimated = "Visa";
export const InstagramAnimated = "Instagram";
export const WhatIsYourFavoriteSocialMedia =
  "What is your favorite social media?";
export const BasicRadioAndCheckboxHeading = "Basic radio and checkbox";
export const SimpleCheckboxHeading = "Simple Checkbox";
export const BasicRadioAndCheckboxBlog = "Blog";
export const BasicRadioAndCheckboxSimpleRadios = "Simple Radios";
export const BasicRadioAndCheckboxMaps = "Maps";
export const RadioToggleButton = "Radio toggle buttons";
export const RadioChecked = "Checked";
export const OutlinedCheckboxStyle = "Outlined checkbox styles";
export const SingleToggle = "Single toggle";
export const ButtonChecked = "Checked";
export const ButtonCheckedSuccessRadio = "Checked success radio";
export const ButtonDarkRadio = "Dark radio";

//Forms Validation
export const ValidationForms = "Validation Forms";
export const FormValidationTooltip = "Tooltip form validation";
export const LooksGood = "Looks good!";
export const UserName = "User Name";
export const UsernameFeedback = "Please choose a unique and valid username.";
export const City = "City";
export const Zip = "Zip";
export const State = "State";
export const StateChoose = "Choose...";
export const CityFeedback = "Please provide a valid city.";
export const StateFeedback = "Please select a valid state.";
export const EnterState = "Enter state";
export const ZipFeedback = "Please provide a valid zip.";
export const SubmitButton = "Submit form";
export const MarkFirstNamePlaceholder = "Mark";
export const OttolastNamePlaceholder = "Otto";
export const BrowserDefaults = "Browser defaults";
export const FirstNamePlaceholder = "First name";
export const EmailPlaceholder = "pesamof475@saeoil.com";
export const PasswordBrowserDefault = "Password";
export const ChooseFile = "Choose file";
export const SelectYourPaymentMethod = "Select your payment method";
export const Visa = "Visa";
export const MasterCard = "MasterCard";
export const Paypal = "Paypal";
export const PayMethodTitle = "Select your payment method";
export const AgreeToThePolicies = "I agree to the policies";
export const SureInformation = "Are you sure above information are true";
export const ValidationsForms = "Validation form";
export const FirstNameError = "Please enter your valid firstname";
export const FirstNameFeedback = "Please enter your valid";
export const PasswordValidation = "Password";
export const PasswordFeedback = "Please enter your valid password";
export const StateInvalidFeedback = "Please select a valid state.";
export const CityInvalidFeedback = "Please provide a valid city..";
export const ZipInvalidFeedback = "Please provide a valid zip.";
export const VISA = "VISA";
export const SelectThemeTitle = "Select Your Favorite Pixelstrap theme";
export const ThemeError = "Invalid select feedback";
export const ChooseFiles = "Choose File";
export const InvalidFormFileSelected = "Invalid form file selected";
export const TextAreaPlaceHolder = "Enter your comment";
export const TextAreaError = "Please enter a message in the textarea.";
export const TermsError = "You must agree before submitting.";
export const AgreeCondition = "Agree to terms and conditions";
export const AgreeSubmitting = "You must agree before submitting.";

//Base Input
export const BaseInputs = "Base inputs";
export const FormBasics = "Basic form";
export const EmailLabel = "Email";
export const EmailPlaceHolder = "Enter Your Email";
export const PasswordLabel = "Password";
export const PasswordPlaceholder = "Enter Your Password";
export const SignInButton = "Sign in";
export const FormFloatingHeading = "Floating form";
export const EmailFloatingPlaceholder = "name@example.com";
export const PasswordFloatingPlaceholder = "Password";
export const FloatingPasswordPlaceholder = "Password";
export const SelectSizings = "Select sizing";
export const WhatsYourHobbies = "What's Your Hobbies";
export const FormControlSizings = "Form control sizing";
export const FormControlSizingsPlaceholder = ".form-control-sm";
export const FileInputs = "File input";
export const FlatInputStyles = "Flat input style";
export const SmallFileInputExample = "Small file input example";
export const LargeFileInputExample = "Large file input example";
export const SelectYourFavoriteRomanNumber =
  "Select your favorite roman number";
export const SelectYourMultiplePaintings = "Select your multiple paintings";
export const PleaseDoComments = "Please do comments";
export const BasicHtmlInputControls = "Basic HTML input control";
export const BasicPlaceholder = "Placeholder";
export const BasicPlaceholderPlace = "Type your title in Placeholder";
export const BasicPassword = "Password";
export const PasswordInputPlaceholder = "Password input";
export const BasicNumber = "Number";
export const NumberPlaceholder = "Number";
export const BasicTelephone = "Telephone";
export const BasicTelephonePlacholder = "91-(999)-999-999";
export const URLs = "URL";
export const URLsValue = "https://getbootstrap.com";
export const BasicDateAndTime = "Date and time";
export const FullDateAndTime = "2018-01-19T18:45:00";
export const BasicDate = "Date";
export const FullDate = "2018-01-01";
export const BasicMonth = "Month";
export const FullMonth = "2018-01";
export const BasicWeek = "Week";
export const FullWeek = "BasicWeek";
export const BasicDatalistExample = "Datalist example";
export const ListPlaceholder = "Look up your nation...";
export const BasicTime = "Time";
export const BasicColorPicker = "Color picker";
export const BasicMaximumLength = "Maximum Length";
export const MaximumLengthPlaceholder = "Content must be in 6 characters";
export const BasicStaticText = "Static Text";
export const StaticTextData = "Hello !... This is my magical text";
export const BasicCancleButton = "Cancle";
export const BasicFloatingInputControls = "Basic floating input control";
export const FloatingValidInput = "Valid input ";
export const InputWithValue = "Input with value";
export const InvalidInput = "Invalid input";
export const FloatingCommentPlaceholder = "Leave a comment here";
export const FloatingComments = "Comments";
export const FloatingEmail = "Email";
export const FloatingPassword = "Password";
export const FloatingComment = "Comments";
export const FloatingCommentLabel = "Comments";
export const InputWithValuePlaceholder = "name@example.com";
export const InvalidInputPlaceholder = "name@example.com";
export const LayOutPlaceholder = "name@example.com";
export const LayOutDefaultvalue = "mdo@example.com";
export const CommentsPlaceholder = "Comments";
export const InputWithValuePlaceholderValue = "test@example.com";
export const InvalidInputPlaceholderValue = "test@example.com";
export const FloatingEmailLabel = "Email address";
export const FloatingOpenLabel = "Open this select menu";
export const FloatOpenFloatingLabel = "Works with selects";
export const FloatingInputGroup = "Input group";
export const FloatingInputGroupLabel = "Username";
export const FloatingInputGroupFeed = "Please choose a username.";
export const FloatingLayout = "Layout";
export const FloatingCancleButton = "Cancle";
export const EdgesInputStyles = "Edges input style";
export const EdgeEmailAddress = "Email address";
export const EdgeEmailAddressPlaceholder = "name@example.com";
export const EdgePassword = "Password";
export const EdgePasswordPlaceholder = "Password";
export const SelectYourFavoritePixelstrapTheme =
  "Select your favorite pixelstrap theme";
export const DefaultFileInputExamples = "Default file input example";
export const MultipleFilesInputExample = "Multiple files input example";
export const DisabledFileInputExample = "Disabled file input example";
export const EdgeDefaultInput = "Default Input";
export const EdgeDefaultInputPlaceholder = "Default Input";
export const EdgeMale = "Male";
export const EdgeFemale = "Female";
export const EdgeComments = "Comments";
export const EdgeCancel = "Cancel";
export const RaiseInputStyles = "Raise input style";
export const RaisedEmailAddress = "Email address";
export const RaisedEmailAddressPlaceholder = "name@example.com";
export const RaisedPassword = "Password";
export const RaisedPasswordPlaceholder = "Password";
export const RaisedCancel = "Cancel";
export const RaisedSelectYourFavoritePixelstrapTheme =
  "Select your favorite pixelstrap theme";
export const SelectTheColorYouLikeBelow = "Select the color you like below";
export const RaisedComments = "Comments";

//Charts - Apex charts
export const Chart = "Chart";
export const Charts = "Charts";
export const BasicAreaCharts = "Basic Area Chart ";
export const AreaSpalineCharts = "Area Spaline Chart";
export const ApexCharts = "Apex charts";
export const BarCharts = "Bar chart";
export const ColumnCharts = "Column Chart ";
export const ProjectCreatedHeading = "Project Created";
export const BubbleCharts = "3d Bubble Chart";
export const SteplineCharts = "Stepline Chart ";
export const ChartColumn = "Column Chart";
export const MonthlyHistoryHeading = "Monthly History";
export const PieCharts = "Pie Chart ";
export const DonutChart = "Donut Chart";
export const MixedCharts = "Mixed Chart";
export const CandlestickCharts = "Candlestick Chart ";
export const RadarCharts = "Radar Chart";
export const RadialBarCharts = "Radial Bar Chart";

//Charts - Google charts
export const GoogleCharts = "Google chart";
export const AreaChartOne = "Area Chart 1";
export const ColumnChartOne = "Column Chart 1";
export const AreaChartTwo = "Area Chart 2";
export const ColumnChartTwo = "Column Chart 2";
export const GanttCharts = "Gantt Chart";
export const LineCharts = "Line Chart";
export const ComboCharts = "Combo Chart";
export const BarChartTwo = "bar-chart2";
export const WordTreeChart = "word tree";
export const PieChartOne = "Pie Chart 1";
export const PieChartTwo = "Pie Chart 2";
export const PieChartThree = "Pie Chart 3";
export const PieChartFour = "Pie Chart 4";

//Charts - ChartJS charts
export const ChartJSCharts = "ChartJS charts";
export const ChartJSBarChart = "Bar Chart";
export const ChatJSLineGraph = "Line Graph";
export const ChatJSRadarGraph = "Radar Graph";
export const ChatJSLineChart = "Line Chart";
export const ChatJSPolarChart = "Polar Chart";

//Buttons
export const Submit = "Submit";
export const Action = "Action";

// SerachResult
export const SearchWebsite = `Search Website`;
export const SearchPages = `Search Pages`;
export const Search = "Search";
export const Images = "Images";
export const Videos = "Videos";
export const Maps = "Maps";
export const SearchPixelStrap = `Search result for "Pixelstrap"`;
export const Pixelstrap = "Pixelstrap ..";
export const FavouriteTVShows = "Favourite TV shows";
export const FavouriteMusicBands = "Favourite Music Bands ";
export const NewLikesThisWeek = "New Likes This Week";
export const MutualFriend = "Mutual Friends";
export const ActivityFeed = "Activity Feed";
export const Photo = "Photo";
export const MoreComments = "More Comments";
export const ProfileIntro = "Profile Intro";
export const SocialNetworks = "Social Networks";
export const Facebook = "Facebook";
export const Tools = "Tools";
export const Audios = "Audios";

// Project
export const ProjectListHeading = "Project List";
export const CreateNewProjects = "Create New Project";
export const All = "All";
export const Doing = "Doing";
export const Issues = "Issues";
export const Resolved = "Resolved";
export const Comment = "Comment";
export const ProjectCreates = "Project Create";
export const Add = "Add";
export const ProjectTitle = "Project Title";
export const ClientName = "Client name";
export const ProjectRate = "Project Rate";
export const ProgressLevel = "Progress Level";
export const ProjectStatus = "Project Type";
export const ProjectSize = "Project Size";
export const Medium = "Medium";
export const Big = "Big";
export const StartingDate = "Starting date";
export const EnterSomeDetails = "Enter some Details";
export const UploadProjectFile = "Upload project file";
export const Apps = "Apps";
export const FileManagerHeading = "File Manager";
export const FileFilter = "File filter";
export const AddNew = "Add New";
export const AllFiles = "All Files";
export const File = "Files";
export const Storage = "Storage";
export const PricingPlan = "Pricing Plan";
export const Selected = "Selected";
export const TrialVersion = "Trial Version";
export const FREE = "FREE";
export const Premium = "Premium";
export const QuickAccess = "Quick Access";
export const Folder = "Folders";
export const Upload = "Upload";

// Calender
export const CalenderHeading = "Calender Basic";
export const DraggableEvents = "Draggable Events";
export const RemoveAfterDrop = "remove after drop";
export const CalendarFilter = "calendar filter";
export const ProjectNamePlaceholder = "Project name *";
export const ClientPlaceholder = "Name client or company name";
export const ProjectProgress = "Project Rate";
export const ProjectProgressPlaceholder = "Enter project Progress";
export const Hourly = "Hourly";
export const FixPrice = "Fix price";
export const Priority = "Priority";
export const PriorityPlaceholder = "Select Status";
export const Low = "Low";
export const ProjectSizePlaceholder = "Select Issues";
export const High = "High";
export const Urgent = "Urgent";
export const EndingDate = "Ending date";
export const Small = "Small";
export const UploadProjectFiles = "Upload project file";
export const ActualFileUpload = " actually uploaded.)";
export const DropFileUploadText =
  "(This is just a demo dropzone. Selected files are ";

// Error
export const BackToHomePage = "BACK TO HOME PAGE";
export const CreateYourAccount = "Create your account";
export const YourName = "Your Name";
export const PrivacyPolicy = "Privacy Policy";
export const AgreeWith = "Agree with";
export const SignUpWith = "Or signup with";
export const Unlock = "Unlock";
export const EnterYourPassword = "Enter your Password";
export const ResetYourPassword = "Reset Your Password";
export const EnterYourMobileNumber = "Enter Your Mobile Number";
export const SignUpToAccount = `Sign Up To Account`;
export const EmailPassWord = `Enter your email & password to login`;
export const HavePassport = "Have Passport";
export const Birthday = "Birthday";
export const RetypePassword = "Retype Password";
export const EnterOTP = "Enter OTP";
export const CreateYourPassword = "Create Your Password";
export const NewPassword = "New Password";
export const MAINTENANCE = `MAINTENANCE`;
export const SignInAccount = "Sign in to account";
export const RememberPassword = "Remember password";
export const ForgotPassword = "Forgot password?";
export const SignInWith = "Or Sign In With";
export const FacebookHeading = "facebook";
export const TwitterHeading = "twitter";
export const LinkedInHeading = "LinkedIn";
export const DoNotAccount = "Don't have account?";
export const CreateAccount = "Create Account";
export const ContactNo = "Contact No";
export const Age = "Age";
export const Send = "Send";
export const Done = "Done";
export const EmailsPlaceHolder = "Test@gmail.com";
export const YesNo = "Yes/No";
export const ConfirmPasswordPlaceholder = "Enter again";
export const MyPortfolioTitle = "My Portfolio";

//Data Tables - Basic Data Tables
export const BasicDataTables = "Basic DataTables";
export const DataTables = "Data Tables";
export const ZeroConfiguration = "Zero Configuration";
export const SearchTableButton = "Search";
export const StateSavingTitle = "State saving";
export const ScrollVerticalDynamicHeightTitle =
  "Scroll - vertical, dynamic height";

//Data Tables - Advance Init
export const AdvanceInit = "Advance Init";
export const StockResultTitle = `Stock Result`;
export const RowCreateCallBackSpan = "Row Create Callback";
export const APIDataTables = "API DataTables";
export const AddRowsTitle = "Add rows";
export const AddNewRowButton = "Add new row";
export const ChildrenRowsTitle =
  "Child rows (show extra / detailed information)";
export const ApiFullName = "Full Name: ";
export const ExtraInfo = "Extra info ";
export const ApiExtensionNumber = "Extension number: ";
export const ApiExtraInfo = "'And any further details here (images etc)...'";
export const RowsSelectionAndDeletions =
  "Row Selection And Deletion (Single Row)";
export const DeleteSelectDataButton = "Delete Row";
export const CustomFilteringSearch = "Custom filtering - range search";
export const MinimumAge = "Minimum age: ";
export const MaximumAge = "Maximum age:	";
export const DATASourceDataTables = "DATA Source DataTables";
export const HtmlTableTittle = "HTML (DOM) sourced data";
export const AjaxSourcedDataHeading = "Ajax sourced data";
export const JavascriptSourcedDataHeading = "Javascript sourced data";
export const ServerSideProcessingHeading = "Server-side processing";

//Job Search
export const JobSearch = "Job Search";
export const CardsView = "Cards View";
export const JobApply = "Apply";
export const JobFilterData = "Job filter";
export const FilterHeading = "Filter";
export const FindJobs = "Find jobs";
export const Fulltime = "Full-time";
export const SearchPlaceholder = "Search..";
export const LocationPlaceholder = "location..";
export const Contract = "Contract";
export const PartTime = "Part-time";
export const Internship = "Internship";
export const Temporary = "Temporary";
export const Commission = "Commission";
export const LocationHeading = "Location";
export const AllLocations = "All Locations";
export const NewYork = "New York";
export const SanFrancisco = "San Francisco";
export const Washington = "Washington";
export const Seattle = "Seattle";
export const Chicago = "Chicago";
export const JobHeading = "Job Title";
export const AllJobTitle = "All Job Title";
export const UIUxDesigner = "UI/Ux designer";
export const GraphicDesigner = "Graphic designer";
export const FrontendDesigner = "Front end designer";
export const PHPdeveloper = "PHP developer";
export const ReactDeveloper = "React Developer";
export const IndustryHeading = "Industry";
export const AllIndustries = "All Industries";
export const ComputerSoftware = "Computer Software";
export const ITEngineer = "IT Engineer";
export const ServiceIndustry = "Service industry";
export const Accounting = "Accounting";
export const SpecificSkills = "Specific skills";
export const AllSkills = "All Skills";
export const FinancialServices = "Financial Services";
export const ListView = "List View";
export const JobDetails = "Job Details";
export const ApplyForThisJob = "Apply";
export const ProductDesignerMainCard = "Product Designer (UI/UX Designer)";
export const EndLessDesigner = "Endless - United States";
export const SimilarJobs = "Similar jobs";
export const JobDescriptionHeading = "Job Description";
export const Qualifications = "Qualifications";
export const AgencyExperience = "Agency experience";
export const JobPersonalDetails = "Personal Details";
export const JobYourEducation = "Your Education";
export const JobYourExperience = "Your Experience";
export const JobUploadYourFiles = "Upload Your Files";
export const Perks = "Perks";
export const Share = "share";
export const JobUIDesigner = "UI Designer";
export const JobCancelButton = "Cancel";
export const FullNameJob = "Full name";
export const FullNameJobPlaceholder = "Enter your full name";
export const EmailJob = "Email";
export const EmailJobPlaceholder = "Enter email";
export const PasswordJob = "Password";
export const PasswordJobPlaceholder = "Enter password";
export const RepeatPasswordJob = "Repeat Password";
export const RepeatPasswordJobPlaceholder = "Repeat password";
export const PhoneNumberJob = "Phone Number";
export const PhoneNumberJobPlaceholder = "Enter Phone no.";
export const CollegeNameJob = "College Name";
export const PeriodJob = "Period";
export const DegreeLevelJob = "Degree Level";
export const SpecializationJob = "Specialization";
export const LocationJob = "Location";
export const PositionJob = "Position";
export const PositionJobPlaceholder = "Enter Position";
export const CompanyNameJob = "Company Name";
export const UploadCoverLetterJob = "Upload Cover Letter";
export const UploadYourCvJob = "Upload Your CV";
export const UploadRecommendationsJob = "Upload Recommendations";
export const BirthDateJob = "Birth Date";
export const CollagePlaceholder = "Enter college name";
export const DegreePlaceholder = "Degree";
export const SpecializationPlaceholder = "Enter specialization";
export const LocationJobPlaceholder = "Enter Location";
export const CompanyJobPlaceholder = "Enter Company Name";
export const SaveThisJob = " Save this job";
export const Apply = "Apply";

// ThemeCustomizer
export const CheckLayouts = "Check layouts";
export const QuickOption = "Quick option";
export const PreviewSettings = "PREVIEW SETTINGS";
export const Layout_Type = "Layout Type";
export const Sidebar_Icon = "Sidebar Icon";
export const UnlimitedColor = "Unlimited Color";
export const Mix_Layout = "MixLayout";
export const Sidebar_Type = "Sidebar Type";
export const Box = "Box";
export const Fill = "Fill";
export const LTRBadges = "LTR";
export const RTLBadges = "RTL";
export const Stroke = "Stroke";
export const Configuration = "Configuration";
export const Subject = "Subject";

// MIS
export const Preview = "Preview";
export const NA = "NA";
export const yes = "yes";
export const token = "token";
export const Shortcuts = "Shortcuts";
export const welcomeCard = "welcomeCard";
export const goToOldMis = "Go To Old MIS";
export const WelcomeModal = "welcomeModal";
export const welcomePath = "dashboard/welcome.png";
export const DailyReportHeading = "Daily Report";
export const ViewReportsHeading = "View Reports";
export const UploadDailyReportHeading = "Upload Daily Report";
export const ImbursementHeading = "Employee Reimbursement Application Form";
export const ContinueDownload = "Please Continue To Download";
export const NoFileAvailable = "No File Available";
export const DailyReportUploadSuccessFully =
  "Daily Report Uploaded Successfully";
export const DownloadFile = "Download File";
export const Name = "Name";
export const TopicSubject = "Topic/Subject";
export const success = "success";
export const primary = "primary";
export const submit = "submit";
export const secondary = "secondary";
export const AddReimbursementForm = "Add Reimbursement";
export const Pending = "pending";
export const Approved = "approved";
export const danger = "danger";
export const infoColor = "info";
export const warningColor = "warning";
export const light = "light";
export const long = "long";
export const short = "short";
export const numeric = "numeric";
export const UploadBill = "Upload Bill";
export const UploadBillImbursement = "Bills/Reimbursement Form";
export const bill = "bill";
export const Category = "Category";
export const MarkAttendanceTitle = "Mark Attendance";
export const ViewAttendanceTitle = "View Attendance";
export const LeavesTitle = "leaves";
export const ConveyanceTitle = "Conveyance";
export const CallingSystem = "Calling System";
export const TrainingVideo = "Training Video";
export const CounsellingSession = "Counselling Session";
export const Imbursement = "Reimbursement";
export const CompanyPolicy = "Company Policy";
export const FullDay = "Full Day";
export const Custom = "Custom";
export const compOff = "comp off";
export const additional_manager = "additional_manager";
export const PersonalInformation = "Personal Information";
export const OfficialInformation = "Official Information";
export const FamilyInformation = "Family Information";
export const EducationInformation = "Education Information";
export const WorkInformation = "Work Information";
export const ExitInitiationTitle = "Initiation Exit";
export const UserExitTitle = "Exit Info";
export const FinancialInformation = "Financial Information";
export const LeaveAppliedSuccessfully = "Leave applied successfully";
export const male = "male";
export const female = "female";
export const userAttendanceData = "userAttendanceData";
export const Logout = "Log Out";
export const darkOnly = "dark-only";
export const darkSidebar = "dark-sidebar";
export const active = "active";
export const unactive = "unactive";
export const Attendance = "Attendance";
export const StartDate = "Start Date";
export const EndDate = "End Date";
export const InLocation = "In Location";
export const OutLocation = "Out Location";
export const Remark = "Remark";
export const InTime = "In Time";
export const OutTime = "Out Time";
export const CorrectionUpdateSuccessfully =
  "Correction Details Updated Successfully";
export const Edit = "Edit";
export const View = "View";
export const click = "click";
export const NoDesignation = "No Designation";
export const announcement = "announcement";
export const press_release = "press_release";
export const pdf = "pdf";
export const xlsx = "xlsx";
export const folder = "folder";
export const OopsNoData = "Oops! there is no data";
export const Assets = "Assets";
export const ApplyLeave = "Apply Leave";
export const pending = "pending";
export const rejected = "rejected";
export const approved = "approved";
export const IN = "IN";
export const OUT = "OUT";
export const NOTYET = "Not In Yet";
export const present = "present";
export const absent = "absent";
export const car = "car";
export const bike = "bike";
export const cab = "cab";
export const rikshaw = "rikshaw";
export const bus = "bus";
export const metro = "metro";
export const auto = "auto";
export const others = "others";
export const ConveyanceSubmittedSuccessfully =
  "Conveyance submitted successfully";
export const conveyances = "conveyances";
export const user_id = "user_id";
export const ConveyanceManagement = "Conveyance Management";
export const AddFields = "Add Fields";
export const source = "source";
export const destination = "destination";
export const distance = "distance";
export const RemoveField = "Remove Field";
export const Mode = "Mode";
export const Distance = "Distance";
export const TravelTo = "Travel To";
export const TravelFrom = "Travel From";
export const Reason = "Reason";
export const forms = "forms";
export const Source = "Source";
export const Conveyance = "Conveyance";
export const AddConveyance = "Add Conveyance";
export const DownloadReimbursementForm = "Outstation Reimbursement Form";
export const TwoDigit = "2-digit";
export const Details = "Details";
export const AM = "AM";
export const PM = "PM";
export const ExpenseManager = "Expense Manager";
export const ExpenseZone = "Expense Zone";
export const AccountZone = "Account Zone";
export const sub = "sub";
export const link = "link";
export const file = "file";
export const Downloads = "Downloads";
export const EmployeeZone = "Employee Zone";
export const ViewAttendance = "View Attendance";
export const ViewLeaves = "View Leaves";
export const ManagerZone = "Manager Zone";
export const AdminZone = "Admin Zone";
export const AttendanceRequests = "Attendance Requests";
export const LeaveRequests = "Leave Requests";
export const SurveyForm = "Survey Form";
export const Department = "Department";
export const TeamMembers = "Team Members";
export const lanClass1 = "lan-1";
export const lanClass3 = "lan-3";
export const lanClass4 = "lan-4";
export const DailyReport = "Daily Report";
export const home = "home";
export const MarkAttendance = "Mark Attendance";
export const maps = "maps";
export const jpeg = "jpeg";
export const jpg = "jpg";
export const png = "png";
export const gif = "gif";
export const webp = "webp";
export const svg = "svg";
export const xls = "xls";
export const csv = "csv";
export const xlsm = "xslm";
export const xlsb = "xlsb";
export const img = "img";
export const excel = "excel";
export const PDF = "PDF";
export const EXCEL = "EXCEL";
export const ViewMoreDetails = "View details";
export const members = "members";
export const status = "status";
export const mode = "mode";
export const username = "username";
export const attachment = "attachment";
export const Cash = "Cash";
export const Online = "Online";
export const Attachment = "Attachment";
export const WorkingHours = "Working Hours";
export const Attachement = "Attachment";
export const Export = "Export";

// Images Classname
export const locationIcon = "icofont icofont-location-pin";
export const locationFontIcon = "icon-location-pin";
export const briefCaseIcon = "fa fa-briefcase";
export const envelopeIcon = "fa fa-envelope-o";
export const powerpointIcon = "fa fa-file-powerpoint-o";
export const videoIcon = "icofont icofont-video-cam";
export const signInIcon = "fa fa-sign-in";
export const pdfIcon = "file-pdf-o";
export const excelIcon = "file-excel-o";
export const chevronLeftIcon = "fa fa-chevron-left";
export const icoRupeeIcon = "icofont icofont-cur-rupee";
export const icoRupeeTrueIcon = `${icoRupeeIcon}-true`;
export const icoRupeePlusIcon = `${icoRupeeIcon}-plus`;
export const icoRupeeMinusIcon = `${icoRupeeIcon}-minus`;
export const jobTypeIcon = "icofont icofont-ui-office";

// Path
export const dashboardPath = "/dashboard";
export const registerPath = "/register";
export const userPath = "/user-management/user";
export const markAttendancePath = "/employee-zone/mark-attendance";
export const leavePath = "/employee-zone/leave";
export const viewAttendancePath = "/employee-zone/view-attendance";
export const conveyancePath = "/employee-zone/conveyance";
export const trainingPath = "/training";
export const imbursementPath = "/reimbursement";
export const policesPath = "/policies";
export const loginPath = "/login";
export const conveyanceManagementPath = "/employee-zone/add-conveyance";
export const dailyReportPath = "/employee-zone/daily-report";
export const teamMembersPath = "/manager/index";
export const membersLeavePath = "/members/leave";
export const membersAttendancePath = "/members/attendance";
export const downloadsPath = "/downloads";
export const downloadFolderIdPath = "/downloads/:folderId";
export const expenseManagerPath = "/expense-zone-manager";
export const expenseAccountZonePath = "/expense-zone-account";
export const managerPath = "/manager/index";
export const surveyFormPath = "/survey/form-lists";
export const departmentPath = "/department/index";
export const managerMembersLeavePath = "/members/leave";
export const managerMembersAttendancePath = "/members/attendance";
export const hrZoneUserPath = "/hr-zone/users";

// Image Paths
export const maleUserImg = "male-user-2.png";
export const femaleUserImg = "female-user.png";
export const userImg = "user.png";
export const welcomeModalImg = "welcome-modal.jpeg";
export const welcomeModalAlt = "welcom-modal";
export const policyImg = "policy.png";
export const leaveImg = "leave.svg";
export const conveyanceImg = "conveyance.svg";
export const announcementImg = "announcement.svg";
export const pressReleaseImg = "press-release.svg";
export const pressReleaseAlt = "press-release";
export const leavePngimg = "leave.png";
export const leaveAlt = "leave";
export const profileImageAlt = "profileImage";

// Form Labels
export const JobType = "Job Type";
export const OfficialEmail = "Official Email";
export const DateOfJoining = "Date Of Joining";
export const QualificationType = "Qualification Type";
export const Gender = "Gender";
export const DateLabel = "Date";
export const VisitTo = "Visit To";
export const Purpose = "Purpose";
export const UploadFile = "Upload File";
export const Members = "Member(s)";
export const TotalAmountExpense = "Total Amount";
export const SelectFile = "Select File";
export const AdditonalManager = "Additional Manager";
export const To = "To";
export const CC = "CC";
export const EmpIdHeading = "Emp Id";
export const CenterHeading = "Center";
export const DepartmentHeading = "Department";
export const DesignationHeading = "Designation";
export const JobTypeHeading = "Job Type";
export const DojHeading = "Doj";
export const DobHeading = "Dob";
export const AnniversaryHeading = "Anniversary";
export const SpouseHeading = "Spouse";
export const FullTimeHeading = "Full Time";
export const ConsultantHeading = "Consultant";
export const intern = "intern";
export const full_time = "full_time";
export const consultant = "consultant";
export const ActiveHeading = "Active";
export const InactiveHeading = "Inactive";
export const DateOfJoiningHeading = "Date Of Joining";
export const Multiple = "Multiple";

// Roles
export const hr = "hr";
export const vip = "vip";
export const user = "user";
export const admin = "admin";
export const manager = "manager";
export const account = "account";
export const officeBoy = "officeboy";
export const inventoryManager = "inventorymanager";

// PlaceHolders
export const SelectDate = "Select Date";
export const SelectAdditionalManager = "Select Additional Manager";
export const AddPurpose = "Add Purpose";
export const AddVisitTo = "Add Visit";
export const SelectMembers = "Select Members";
export const DailyReportDescription = "Enter Daily Report Description";
export const ReportingManger = "Reporting Manager";
export const SelectUser = "Select User";
export const SelectStartDate = "Select Start Date";
export const SelectEndDate = "Select End Date";

// Form Names
export const dateOfJourney = "dateOfJourney";
export const visitTo = "visitTo";
export const purpose = "purpose";
export const uploadBill = "uploadBill";
export const additionalManager = "additionalManager";
export const amount = "amount";
export const description = "description";
export const dailyReportDate = "dailyReportDate";
export const dailyReportFile = "dailyReportFile";
export const dailyReportDescription = "dailyReportDescription";
export const to = "to";
export const cc = "cc";

// Tables Heading
export const Destination = "Destination";
export const Amount = "Amount";
export const Bill = "Bill";
export const Status = "Status";
export const Type = "Type";
export const TotalDays = "Total Days";
export const ApprovedBy = "Approved By";

// Form Validation Errors
export const fileSize = "fileSize";
export const FileRequired = "File is required";
export const FileExceed1MB = "File size should not exceed 1MB";
export const DescriptionRequired = "Description Required";
export const AmountRequired = "Amount Required";
export const AmountGreaterZero = "Amount should be greater than zero";
export const CategoryRequired = "Category is required";
export const categoryType = "categoryType";
export const PurposeRequired = "Purpose is required";
export const Outstation = "Outstation";
export const Meal = "Meal";
export const DateRequired = "Date is required";
export const InvalidDateFormat = "Invalid date format";
export const ReasonRequired = "Reason is required";
export const ReasonExceed = "Reason cannot exceed 255 characters";
export const TravelFromRequired = "Travel From is required";
export const TravelFromExceed = "Travel From cannot exceed 100 characters";
export const TravelToRequired = "Travel To is required";
export const TravelToExceed = "Travel To cannot exceed 100 characters";
export const DistanceRequired = "Distance is Required";
export const DistanceNumberRequired = "Distance must be a number";
export const DistancePositiveRequired = "Distance must be positive";
export const ModeRequired = "Mode is required";
export const InvalidMode = "Invalid mode selected";
export const AmountPositiveRequired = "Amount must be a number";
export const AmountAtLeastOne = "Amount must be at least 1";
export const FileSizeTooLarge = "File size is too large";
export const fileType = "fileType";
export const UnsupportedFormated = "Unsupported file format";
export const FormRequired = "Forms are required";
export const PaymentModeRequired = "Payment mode is required";
export const UserRequired = "User is required";
export const ManagerRequired = "Manager is required";

// Modals
export const ReimbursementModal = "imbursementModal";
export const ReimbursementModalBills = "imbursementModalBill";
export const ReimbursementFormModal = "Reimbursement";
export const ReimbursementBill = "Reimbursement Bill";
export const personalInformationModal = "personalInformationModal";
export const jobInformationModal = "jobInformationModal";
export const familyInformationModal = "familyInformationModal";
export const educationInformationModal = "educationInformationModal";
export const workInformationModal = "workInformationModal";
export const financialInformationModal = "financialInformationModal";
export const attendanceCorrectionModal = "attendanceCorrectionModal";
export const AttendanceCorrection = "Attendance Correction";
export const announcementModal = "annoucementModal";
export const userInformationModals = "userInformationModals";
export const leaveApplyModal = "leaveApplyModal";
export const ReimbursementUserDetailsModal = "imbursementUserDetailsModal";
export const ReimbursementDetailModal = "Reimbursement Details";
export const ConveyanceDetailsModal = "conveyanceDetailsModal";
export const ConveyanceAttachementModal = "conveyanceAttachementModal";
export const ConveyanceDetails = "Conveyance Details";
export const ConveyanceAttachementDetails = "Conveyance Attachement Details";
export const PettyCashExpenseModal = "addPettyCashExpenseModal";
export const PettyCashExpenseAttachmentModal =
  "attachmentPettyCashExpenseModal";
export const AddSurveyFormModal = "addSurveyFormModal";
export const AddDepartmentModal = "addDepartmentFormModal";
export const EditDepartmentModal = "editDepartmentModal";
export const PettyCashAddMoneyModal = "addMoneyBalancePettyCashModal";
export const updateManagerModal = "updateManagerModal";
export const aadharCardModal = "aadharCardModal";
export const panCardModal = "panCardModal";
export const certificateModal = "certificateModal";
export const approvalLeaveModal = "approvalLeaveModal";
export const approvalAttendanceModal = "approvalAttendanceModal";
export const pettyCashExpenseDeleteDialog = "pettyCashExpenseDeleteDialog";
export const conveyanceDeleteDialog = "conveyanceDeleteDialog";
export const reimbursementDeleteDialog = "reimbursementDeleteDialog";
export const userEditOptionDialog = "userEditOptionDialog";
export const bulkApprovedAttendanceDialog = "bulkApprovedAttendanceDialog";
export const bulkApprovedLeaveRequestDialog = "bulkApprovedLeaveRequestDialog";
export const bulkApprovedLeaveTeamRequestList =
  "bulkApprovedLeaveTeamRequestList";
export const exportCustomCSVDialog = "exportCustomCSVDialog";
export const exportUserMasterDialog = "exportUserMasterDialog";
export const exportReimbursementReportDialog =
  "exportReimbursementReportDialog";
export const viewConveyanceBillReportModal = "viewConveyanceBillReportModal";
export const exportConveyanceReportDialog = "exportConveyanceReportDialog";
export const exportBulkAttendanceReportDialog =
  "exportBulkAttendanceReportDialog";
export const exportBulkEmployeeSalaryReportDialog =
  "exportBulkEmployeeSalaryReportDialog";
export const salaryReportCorrectionModal = "salaryReportCorrectionModal";
export const exportEmployeeLeaveReportDialog =
  "exportEmployeeLeaveReportDialog";
export const teamMembersConveyanceBillModal = "teamMembersConveyanceBillModal";
export const employeeUpdateProbationModal = "employeeUpdateProbationModal";
export const employeeMonthWiseReportDialog = "employeeMonthWiseReportDialog";
export const bulkApprovedAttendanceTeamRequestList =
  "bulkApprovedAttendanceTeamRequestList";

// Tabs
export const About = "About";
export const Work = "Work";
export const Finance = "Finance";
export const Job = "Job";

// Leaves
export const CasualLeave = "casual leave";
export const casualLeave = "casualleave";
export const startDate = "startDate";
export const endDate = "endDate";
export const custom = "custom";
export const leaveTypeRemark = "leaveTypeRemark";
export const customDate = "customDate";
export const reason = "reason";
export const CompOff = "comp off";
export const compOffDateField = "compOffDate";
export const FirstHalf = "First Half";
export const SecondHalf = "Second Half";
export const LeaveType = "Leave Type";
export const LeaveTypes = "Leave Types";

// Register Forms
export const ErrorCreateAccount = "Error in create account";
export const PersonalDetails = "Enter your personal details to create account";
export const EnterFirstName = "Enter first name";
export const EnterLastName = "Enter last name";
export const Intern = "Intern";
export const Fresher = "Fresher";
export const ExperienceFullTime = "Experience/Full Time";
export const Diploma = "Diploma";
export const UnderGraduate = "Undergraduate (UG)";
export const PostGraduate = "Postgraduate (PG)";
export const AlreadyAccount = "Already have an account?";
export const AccountCreateSuccessfully =
  "The account has been created successfully.";

// Errors
export const ErrorOccured = "An error occured";
export const UnknownErrorOccured = "An unknown error occured";
export const NetworkUnknownError = "Network or unknown error";
export const UnhandledApiError = "Unhandled API error";
export const ServerError = "Server Error";
export const BadRequestError = "Bad Request";
export const UnauthorizedUser = "Unauthorized Error";
export const NotFoundError = "Not found";
export const UnproccessableContentError = "Unproccessable Content Errror Code";

// Excluded Keys
export const departmentId = "departmentId";
export const centerId = "centerId";
export const dob = "dob";
export const doj = "doj";
export const userId = "userId";
export const profile = "profile";
export const alternateMobileNumber = "alternateMobileNumber";
export const name = "name";
export const managerId = "managerId";
export const managerEmail = "managerEmail";
export const additionalManagerEmails = "additionalManagerEmails";
export const additionalManagerIds = "additionalManagerIds";
export const spouseContact = "spouseContact";
export const spouseName = "spouseName";
export const spouseOccupation = "spouseOccupation";
export const anniversaryDate = "anniversaryDate";
export const updated_at = "updated_at";
export const created_at = "created_at";
export const updatedby = "updatedby";
export const sip = "sip";
export const addedby = "addedby";
export const id = "id";
export const course_id = "course_id";
export const edu_option = "edu_option";
export const education_id = "education_id";
export const employeeCode = "employeeCode";
export const email = "email";
export const mobileNumber = "mobileNumber";
export const department = "department";
export const subDepartment = "subDepartment";
export const designation = "designation";
export const location = "location";
export const currentAddress = "currentAddress";
export const currentState = "currentState";
export const currentPincode = "currentPincode";
export const currentStreet = "currentStreet";
export const permanentAddress = "permanentAddress";
export const permanentState = "permanentState";
export const permanentPincode = "permanentPincode";
export const permanentStreet = "permanentStreet";
export const single = "single";

// Petty Cash
export const OpeningBalance = "Opening Balance";
export const WalletBalance = "Wallet Balance";
export const TotalAddedMoney = "Added Money";
export const TotalExpenses = "Total Expense(s)";
export const AddExpense = "Add Expense";

// Local Storage Keys
export const config = "config";
export const conveyanceListKey = "conveyanceList";
export const conveyanceStartDateKey = "conveyanceStartDate";
export const conveyanceEndDateKey = "conveyanceEndDate";
export const profileConveyanceListKey = "profileConveyanceList";
export const profileConveyanceStartDateKey = "profileConveyanceStartDate";
export const profileConveyanceEndDateKey = "profileConveyanceEndDate";
export const leaveListKey = "leaveList";
export const profileLeaveListKey = "profileLeaveList";
export const attendanceListKey = "attendanceList";
export const attendanceStartDateKey = "attendanceStartDate";
export const attendanceEndDateKey = "attendanceEndDate";
export const profileAttendanceListKey = "profileAttendanceList";
export const profileAttendanceStartDateKey = "profileAttendanceStartDate";
export const profileAttendanceEndDateKey = "profileAttendanceEndDate";
export const employeeManagerPaginationPerPage =
  "employeeManagerPaginationPerPage";
export const attendancePaginationPerPageKey = "attendancePaginationPerPage";
export const profileAttendancePaginationPerPageKey =
  "profileAttendancePaginationPerPage";
export const employeeManagerUserListKey = "employeeManagerUserList";
export const leavePaginationPerPageKey = "leavePaginationPerPage";
export const profileLeavePaginationPerPageKey = "profileLeavePaginationPerPage";
export const conveyanceManagementPerPageKey = "conveyanceManagementPerPage";
export const profileConveyanceManagementPerPageKey =
  "profileConveyanceManagementPerPage";

export const paginationRowsPerPageOptions = [
  5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 150, 200, 250, 300, 350, 400, 450,
  500,
];

// Export Table Headers
export const EMPLOYEE_NAME = "Employee Name";
export const TOTAL_DAYS = "Total Days";
export const PRESENT_DAYS = "Present Days";
export const ABSENT_DAYS = "Absent Days";
export const EMPLOYEE_REPORT = "Employee Report";
export const EMPLOYEE_SALARY_REPORT_XLSX = "Employee_Salary_Report.xlsx";
export const EXPORT_FAILED_ERROR = "Export failed:";
export const EXPORT_FAILED_ERROR_MESSAGE =
  "Failed to export the report. Please try again.";
export const CONFIRM_EXPORT_EMPLOYEE_SALARY_REPORT =
  "Do you want to export the employee salary report?";
export const SELECT_DATES = "Select Dates";
export const Designation = "Designation";
export const Inventory = "Inventory/Assets";
export const Centers = "Centers";
